import { useCallback } from 'react';
import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { BUDGET_CALCULATION_FRAGMENT, BUDGET_FORM_DATA_FRAGMENT } from 'graphql/fragments/budget';
import { formatGraphqlErrors } from 'utils/helpers';

const UPDATE_BUDGET_MUTATION = gql`
  mutation updateBudget($formData: UpdateBudgetInput!) {
    updateBudget(formData: $formData) {
      _id
      pdf
      ...budgetCalculation
      ...budgetFormData
    }
  }
  ${BUDGET_CALCULATION_FRAGMENT}
  ${BUDGET_FORM_DATA_FRAGMENT}
`;

const useUpdateBudget = () => {
  const [updateBudgetMutation] = useMutation(UPDATE_BUDGET_MUTATION);

  const updateCalculatedBudgetValues = useCallback(
    async (formData) => {
      try {
        const {
          data: { updateBudget },
        } = await updateBudgetMutation({ variables: { formData } });

        return updateBudget;
      } catch (error) {
        const e = formatGraphqlErrors(error);
        throw e;
      }
    },
    [updateBudgetMutation],
  );
  return updateCalculatedBudgetValues;
};

export default useUpdateBudget;
